import React from 'react'

const ObjectContext = React.createContext()

export default ObjectContext
